import { SETTING_LABELS, SettingChange, formatDate, page } from '@deizi/shared';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ErrorBox, Skeleton } from '../../../components/States';
import { api } from '../../../lib/api';
import { formatSettingValue } from './format';

const History = page(SettingChange);

/** "Histórico de parâmetros" aside. */
export function HistoryPanel({ filter }: { filter: 'costs' | 'rules' }) {
  const history = useInfiniteQuery({
    queryKey: ['settings', 'history'],
    queryFn: ({ pageParam }) =>
      api.get(`/settings/history?limit=30${pageParam ? `&cursor=${pageParam}` : ''}`, History),
    initialPageParam: '',
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
  const rows = (history.data?.pages ?? [])
    .flatMap((p) => p.data)
    .filter((r) => r.param.startsWith(`${filter}.`));
  const cols = '86px 1.2fr 1fr 64px';
  return (
    <aside className="card flat" style={{ flex: '2 1 340px', minWidth: 0 }}>
      <div style={{ padding: '16px 18px 6px' }}>
        <h2>Histórico de parâmetros</h2>
      </div>
      {history.isPending ? <Skeleton rows={3} height={40} /> : null}
      {history.isError ? (
        <ErrorBox
          title="Não foi possível carregar o histórico"
          onRetry={() => void history.refetch()}
        />
      ) : null}
      {history.isSuccess && rows.length === 0 ? (
        <p className="sm muted" style={{ padding: '6px 18px 16px' }}>
          Nenhuma mudança ainda. Cada alteração aparece aqui com o motivo.
        </p>
      ) : null}
      {rows.length > 0 ? (
        <div className="gt">
          <div className="gtr head" style={{ gridTemplateColumns: cols }}>
            <span>Data</span>
            <span>Parâmetro</span>
            <span className="num">De → para</span>
            <span>Quem</span>
          </div>
          {rows.map((r) => (
            <div key={r.id} className="gtr" style={{ gridTemplateColumns: cols }}>
              <span className="tab sm">{formatDate(r.at)}</span>
              <span>
                {SETTING_LABELS[r.param] ?? r.param}
                {r.reason ? (
                  <span className="xs muted" style={{ display: 'block' }}>
                    {r.reason}
                  </span>
                ) : null}
              </span>
              <span className="num sm">
                {formatSettingValue(r.param, r.oldValue)} →{' '}
                {formatSettingValue(r.param, r.newValue)}
              </span>
              <span className="sm trunc" title={r.actor}>
                {r.actor}
              </span>
            </div>
          ))}
        </div>
      ) : null}
      {history.hasNextPage ? (
        <div style={{ padding: '8px 18px' }}>
          <button type="button" className="btn sm g" onClick={() => void history.fetchNextPage()}>
            Ver mais
          </button>
        </div>
      ) : null}
      <p className="xs muted" style={{ padding: '12px 18px 16px' }}>
        Operadores veem estes valores, mas só Admin altera.
      </p>
    </aside>
  );
}
